export function isLoading(state) {
	return state.loading.inProgressActions?.length > 0 ?? false;
}

export function getInProgressActions(state){
	return state.loading?.inProgressActions;
}

export function getLoadingType(state){
	return state.loading?.loadingType;
}
